import { useSelector } from "react-redux";

export function useCosmeticConsultationFlow() {
  return useSelector((state) => {
    return state.cosmeticConsultationFlow;
  });
}
